'use strict';
var BASWebServices;
(function (BASWebServices) {
    var RemoveSpacesAndPunctuationFilter = (function () {
        function RemoveSpacesAndPunctuationFilter() {
        }
        RemoveSpacesAndPunctuationFilter.Factory = function () {
            return function (input) {
                if (angular.isString(input)) {
                    var retVal = input;
                    var replacements = ['\\?', '\\.', ',', ':', '-', '_', '\'', '\"', '/', '\\\\', "\\s\\s+"];
                    for (var currIdx in replacements) {
                        var currReplacement = replacements[currIdx];
                        retVal = BASWebServices.Helper.replaceAll(retVal, currReplacement, ' ');
                    }
                    retVal = RemoveSpacesAndPunctuationFilter.titleCase(retVal);
                    retVal = retVal.replace(/ /g, '');
                    return retVal;
                }
                else if (input === 'undefined') {
                    return null;
                }
                else if (input === undefined) {
                    return null;
                }
                else {
                    return input;
                }
            };
        };
        RemoveSpacesAndPunctuationFilter.titleCase = function (str) {
            str = str.toLowerCase()
                .split(' ')
                .map(function (word) {
                if (word != "") {
                    return word.replace(word[0], word[0].toUpperCase());
                }
                else {
                    return "";
                }
            });
            return str.join(' ');
        };
        return RemoveSpacesAndPunctuationFilter;
    }());
    BASWebServices.RemoveSpacesAndPunctuationFilter = RemoveSpacesAndPunctuationFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=RemoveSpacesAndPunctuationFilter.js.map